import React, { useEffect, useRef } from "react";

// ASSETS

// STYLES
import {
  LayoutContainer,
  HeaderWrapper,
  ContentContainer,
  FooterWrapper,
  GirdleWrapper,
} from "./LayoutWrapperStyled";

// LIBRARIES
import { Outlet } from "react-router-dom";
import { useLocation } from "react-router-dom";
import { useMediaQuery } from "react-responsive";

// MISC
import { ILayoutContext } from "./LayoutWrapperModel";
import { appRoutes } from "config/AppRoutesConfig";

// COMPONENTS
import Header from "components/Header/Header";
import Footer from "components/Footer/Footer";
import HeaderMobile from "components/HeaderMobile/HeaderMobile";
// import Girdle from "components/Girdle/Girdle";

// CONFIGURATION
const LayoutWrapper = (props: ILayoutContext) => {
  const { hasHeader = true } = props;

  // PROPERTIES

  // API REQUESTS

  // LIBRARY CONSTANTS
  const location = useLocation();
  const { pathname } = useLocation();
  const isMobile = useMediaQuery({ maxWidth: 1370 });

  // STATE CONSTANTS

  const noFooterRoutes = [
    appRoutes.map,
    appRoutes.legislation,
    appRoutes.news,
    new RegExp(`^${appRoutes.map}/[^/]+$`),
  ];
  const isRouteMatch = noFooterRoutes.some((route) => {
    if (route instanceof RegExp) {
      return route.test(location.pathname);
    }
    return route === location.pathname;
  });

  // LIFE CYCLE
  useEffect(() => {
    setTimeout(() => {
      topOfPageRef.current.scrollIntoView({
        behavior: "smooth",
        block: "start",
      });
    }, 0);
  }, [pathname]);

  // EVENT HANDLERS

  const topOfPageRef = useRef(null);

  const handleScrollToTop = () => {
    topOfPageRef.current.scrollIntoView({
      behavior: "smooth",
      block: "start",
    });
  };

  return (
    <LayoutContainer ref={topOfPageRef}>
      {hasHeader && (
        <HeaderWrapper>
          {isMobile ? (
            <HeaderMobile handleScrollToTop={handleScrollToTop} />
          ) : (
            <Header handleScrollToTop={handleScrollToTop} />
          )}
        </HeaderWrapper>
      )}
      <ContentContainer noFooter={isRouteMatch}>
        <Outlet />
      </ContentContainer>
      {!isRouteMatch && (
        <FooterWrapper>
          <Footer handleScrollToTop={handleScrollToTop} />
        </FooterWrapper>
      )}
        {/* <GirdleWrapper>
            <Girdle />
        </GirdleWrapper> */}
    </LayoutContainer>
  );
};

export default LayoutWrapper;
